<template>
	<div class="container">
		<img class="page_bk" src="@/assets/about_bk.png"/>
		<div class="content_wrap">
			<div class="title_label">About us</div>
			<div class="content_label">Adorime is a fun and engaging social application based on interests, location, and diverse matching methods, combined with hardware. Hutoo is committed to creating a "social metaverse" that connects people with people and people with objects, transforming social interactions from a two-dimensional world to a tangible and warm experience using web3.0 technology. In the world of Adorime, users can freely express themselves, understand others, explore new joys, and achieve higher levels of social interaction through communication and physical sensations.

Through various algorithms and machine learning, Adorime matches users with similar interests, high-quality friends, and provides various novel and interesting interactive ways. With the widespread adoption of new technologies such as the metaverse and artificial intelligence, Adorime will continue to evolve and utilize new technologies to build an immersive social network.</div>
			
	<!-- 		<div class="bottom-menu">
				<div class="link_label" @click="linkClick">深圳市互逗科技有限公司  ICP备案号：粤ICP备2023021638号-1</div>
			</div> -->
			
			<div class="bottom-footer">
			</div>
			
		</div>
		
		
	</div>
</template>

<script>
	export default{
		props:{
			clientWidth:0
		},
		
		data(){
			return {
			}
		},
		
		// methods:{
		// 	linkClick() {
		// 	    location.href="https://beian.miit.gov.cn/"
		// 	}
		// }
	}
</script>

<style scoped>
	
	.container{
		width: 100%;
		height: 100%;
		position: relative;
	}
	
	.page_bk{
		position: absolute;
		left: 0;
		top: 0;
		width: 100vw;
		height: 100vh;
	}
	
	
	.content_wrap{
		position: absolute;
		left: 0;
		top: 0;
		width: 100vw;
	}
	
	
	.title_label{
		margin-left: 50px;
		font-size: 30px;
		color: white;
		margin-top: 60px;
	}
	
	.content_label{
		margin-top: 30px;
		margin-left: 50px;
		margin-right: 50px;
		font-size: 16px;
		color: white;
	}
	
	.bottom-menu{
		margin-top: 30px;
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.link_label{
		color: #919191;
		font-size: 17px;
	}
	
	.bottom-footer{
		width: 100vw;
		height: 60px;
	}
	
</style>